<template>
  <div class="approved_box">
    <ax-result-page v-if="showResult" type="network" subtext="要不然下拉刷新试试？"></ax-result-page>
    <div v-if="!showResult&&showContent">
      <div class="number">单号：{{instanceId}}</div>
      <ax-head>
        <div slot="ing" v-if="action">
          <p>
            来自{{data.header.dept_descr}}的
            <em>{{data.header.emplid_description}}</em>的
            <em>员工个人信息修改申请单</em>，请您审批。
          </p>
        </div>
        <div slot="over" v-else>
          <p>您已审批</p>
        </div>
      </ax-head>
      <!-- <ax-panel title="更改信息">
        <van-cell title="更改类型">
          <span v-if="data.header.qh_phone_flag ==='Y'">电话号码</span>
          <span v-if="data.header.qh_phone_flag ==='Y'&&data.header.qh_photo_flag ==='Y'">、</span>
          <span v-if="data.header.qh_photo_flag ==='Y'">照片</span>
        </van-cell>
        <van-cell title="电话号码" v-if="data.header.qh_phone_flag ==='Y'" v-model="data.header.phone">
          <a class="link_a" :href="'tel:'+data.header.phone">{{data.header.phone}}</a>
        </van-cell>
        <van-cell title="照片" v-if="data.header.qh_photo_flag ==='Y'">
          <img class="img-part" :src="'data:image/jpeg;base64,'+data.photo_data" alt="照片" />
        </van-cell>
        <van-cell title="申请说明" v-if="data.header.comments!==''" v-model="data.header.comments"></van-cell>
      </ax-panel>
      <ax-panel title="申请人信息">
        <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
        <van-cell title="邮箱" v-if="data.header.email_addr">
          <a class="mail_a" :href="'mailto:'+data.header.email_addr">{{data.header.email_addr}}</a>
        </van-cell>
        <van-cell title="电话">
          <a class="link_a" :href="'tel:'+data.header.emplid_phone">{{data.header.emplid_phone}}</a>
        </van-cell>
        <van-cell title="部门" :value="data.header.deptid_description"></van-cell>
      </ax-panel>-->
      <personal-form :data="data"></personal-form>
      <div v-if="action">
        <ax-panel title="审批意见">
          <textarea class="comments_box" rows="5" v-model="comments" placeholder="请输入您的审批意见"></textarea>
        </ax-panel>
        <div class="handle_box">
          <a class="reject" href="javascript:;" @click="handleApproval(-1)">拒绝</a>
          <a class="approve" href="javascript:;" @click="handleApproval(1)">同意</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { fetchData } from '@/api/ehr'
  import personalForm from '@/backup/ehr/personal.vue'
  export default {
    name: 'approvalDetails',
    components: {personalForm},
    data() {
      return {
        instanceId: this.$route.query.instanceId,
        emplId: this.$route.query.emplId,
        version: this.$route.query.version || 0.0,
        data: {},
        comments: '',
        showResult: false,
        showContent:false,
        timer: null,
        action: false,
        toast: null
      }
    },
    created() {
      this.toast = this.$toast.loading({mask: false,message: '加载中...',duration: 0});   
      this.getDetailsData();
    },
    methods: {
      getDetailsData() {
        fetchData('loadPersonalDetails',{
          "data":{
            "instance_id": this.instanceId
          },
          "emplId": this.emplId
        }).then(response => {
          this.toast.clear();
          if(response.data.success === true) {
            this.data = response.data.data;
            response.data.data.action === 'U'?this.action = true:this.action = false;
            this.showContent = true;
          }else{
            this.showResult = true;
          }
        }).catch(() => {
          this.toast.clear();
          this.showResult = true;
        });
      },
      handleApproval(item){
        let name = item === 1?'同意':'拒绝',
            query = {
              "jumpType": item === 1?'AGREE':'BACK_TO_STARTOR',
              "instId": this.instanceId,
              "version": this.version,
              "platform": "ehr", 
              "opinion": this.comments,
              "jsonData": JSON.stringify({
                "service_type": "personal",
                "emplid": this.data.header.emplid,
                "empl_rcd": this.data.header.empl_rcd,
                "action_dt_ss": this.data.header.action_dt_ss,
                "effseq": this.data.header.effseq,
                "comments": this.comments
              }),
              extJsonData:""
            };

        if(this.version <= 1.0){
          this.checkVersion();
          return
        }
        
        if(item === -1){
          if(this.comments === ''){
            this.toast = this.$toast({
              message: '请您输入审批意见',
              duration: 1500
            });
            return
          }
        }
        
        this.$dialog.confirm({
          title: '提示',
          message: '确定执行'+name+'操作?',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.toast = this.$toast.success({
                message: '审批成功',
                duration: 1500
              });
              iqh.approveOrder(query)
              done()
            } else {
              done()
            }
          }
        }).catch(() => {});
      }
    },
    beforeDestroy() {
      this.toast.clear();
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>